import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { QuotationsState } from '../../types/types.facturacion';

const initialState: QuotationsState = {
  Mode: 'view',
  ModePatient: 'view',
  Quotation: { AditionalFields: {}, Cz_Cn_Id: 0, Cz_Id: 0 },
  IdQuotation: -1,
  ModalPatient: false,
  LoadingPatient: false,
  Loading: false,
  PatientData: null,
};

//Encargado de manejar todas las órdenes del sistema y configuración general

export const quotationSlice = createSlice({
  name: 'QuotationGlobal',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.Loading = action.payload;
    },
    setMode: (state, action: PayloadAction<{ mode: 'new' | 'update' | 'view' | 'loading'; idQuotation?: number }>) => {
      state.Mode = action.payload.mode;
      state.Loading = false;

      if (action.payload.mode === 'new') {
        state.Quotation = { AditionalFields: {}, Cz_Cn_Id: 0, Cz_Id: 0 };
        state.PatientData = null;
      }
      if (action.payload.mode === 'view' && action.payload.idQuotation !== -1) {
        state.Quotation.Cz_Id = action.payload.idQuotation;
      }
      if (action.payload.mode === 'view' && action.payload.idQuotation === -1) {
        state.Quotation = { AditionalFields: {}, Cz_Cn_Id: 0, Cz_Id: 0 };
        state.PatientData = null;
      }
    },
    setData: (state, action: PayloadAction<any>) => {
      //Asignar los datos pero eliminar el nodo paciente, ya que este va en state.PatientData y eliminar el nodo Detalle
      state.Quotation = { ...action.payload };
      //El nodo Cz_CamposDinamicos es el equivalente a AditionalFields, solo que actualmente esta como string, asi que se convierte a objeto y se asigna
      if (state.Quotation.Cz_CamposDinamicos) {
        state.Quotation.AditionalFields = JSON.parse(state.Quotation.Cz_CamposDinamicos);
      }
      delete state.Quotation.Cz_CamposDinamicos;
      delete state.Quotation.Paciente;
      delete state.Quotation.Detalle;
      //Asignar el paciente
      state.PatientData = action.payload.Paciente;
      state.Mode = 'view';
    },
    setPatient: (state, action: PayloadAction<any>) => {
      state.PatientData = action.payload;
    },
    clearPatient: (state) => {
      state.PatientData = { Pc_Identificacion: '' };
    },
    clearQuotation: (state) => {
      state = initialState;
    },
    updateFieldQuotation: (state, action: PayloadAction<{ field: string; castMode: 'UPPER' | 'LOWER' | null; value: any }>) => {
      const { field, castMode, value } = action.payload;
      let resp = value;
      switch (castMode) {
        case 'LOWER':
          resp = value.toString().toLocaleLowerCase();
          break;
        case 'UPPER':
          resp = value.toString().toUpperCase();
          break;
      }
      if (field.includes('AditionalFields')) {
        state.Quotation.AditionalFields[field.split('.')[1]] = resp;
        return;
      }
      state.Quotation[field] = resp;
    },
  },
});

export const { setLoading, setMode, setPatient, clearPatient, updateFieldQuotation, clearQuotation, setData } = quotationSlice.actions;
